import React from 'react';

import PropTypes from 'prop-types';

const PageTitle = ({ title }) => (
    <title>{title ? `${title} | Producer News Portal` : 'Producer News Portal'}</title>
);

PageTitle.propTypes = {
    title: PropTypes.string,
};

export { PageTitle };
